import styles from "./Emoji.module.scss"

import React, { MouseEvent } from "react"

import { VISITOR_COUNT } from "@shared/constants"

import classNames from "classnames"

interface Props {
  name: string
  width?: number | string | undefined
  height?: number | string | undefined
  onClick?: (e: MouseEvent<HTMLImageElement>) => void | undefined
  fileExt?: string
}

function Emoji({
  name,
  width = 70,
  height = 70,
  onClick,
  fileExt = "gif",
}: Props) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/Assets/Emoticons/${name}.${fileExt}`}
      style={{ width: width, height: height }}
      decoding="async"
      className={classNames(styles.emoji, {
        [styles.focusEmoji]: onClick,
        [styles.celebrateEmoji]: VISITOR_COUNT.includes(name),
      })}
      onClick={onClick}
      alt={name}
    />
  )
}

export default Emoji
